/** Illustration panel height — room for scaled demo canvas + slide copy below. */
export const ONBOARDING_ILLUSTRATION_CLASS =
  'h-[min(38vh,240px)] sm:h-[min(42vh,280px)] md:h-[min(48vh,320px)]';

export const DEMO_ROOT_CLASS =
  'flex h-full w-full min-h-0 flex-col items-center justify-center';

export const DEMO_FRAME_CLASS =
  'relative h-full w-full min-h-0 overflow-hidden';
